module.exports = __webpack_public_path__ + "static/media/BN.54439dba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/BN.svg
// module id = 208
// module chunks = 0